export default class BaseService {
    static getData(response) {
        return response?.data?.data;
    }

    static getResponse(response) {
        return response?.data;
    }
}
